import { render, staticRenderFns } from "./SetReason.vue?vue&type=template&id=38c13cd0&scoped=true&"
import script from "./SetReason.vue?vue&type=script&lang=js&"
export * from "./SetReason.vue?vue&type=script&lang=js&"
import style0 from "./SetReason.vue?vue&type=style&index=0&id=38c13cd0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c13cd0",
  null
  
)

export default component.exports